/* eslint indent: [2, 2, { "SwitchCase": 1 }] */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import loadModal from 'action/loadModal';
import { appContext } from '../../util/decorators';
import Overlay from 'component/Overlay';
import Signup from 'component/Account/Signup';
import FollowFacebook from './FollowFacebook';
import FollowTwitter from './FollowTwitter';
import FollowEmail from './FollowEmail';
import FeedbackForm from 'component/Feedback/FeedbackForm';
import socialMediaConfig from 'config/socialMedia.json';

const ESC_KEY = 27;
const toBeBlurred = ['header', 'main-content'];

const mapStateToProps = state => ({
  modal: state.modal,
  socialMediaLinks: socialMediaConfig[state.country],
});

@connect(mapStateToProps)
@appContext
export default class Modal extends React.PureComponent {
  static propTypes = {
    modal: PropTypes.string,
    socialMediaLinks: PropTypes.shape({
      facebook: PropTypes.array,
      twitter: PropTypes.array,
    }),
    dispatch: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.closeOnClick = this.closeOnClick.bind(this);
    this.closeOnEsc = this.closeOnEsc.bind(this);
    this.removeModal = this.removeModal.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.modal && nextProps.modal) {
      this.showModal();
    } else if (this.props.modal && !nextProps.modal) {
      this.hideModal();
    }
  }

  showModal() {
    window.addEventListener('keydown', this.closeOnEsc);
    window.addEventListener('popstate', this.removeModal);
    window.history.pushState(null, null);
    document.body.style.overflow = 'hidden';
    document.getElementById('main-content').setAttribute('aria-hidden', 'true');
    document.getElementById('header').setAttribute('aria-hidden', 'true');
    toBeBlurred
      .map(id => document.getElementById(id))
      .filter(Boolean)
      .forEach(element => element.classList.add('blurred-global'));
  }

  hideModal() {
    window.removeEventListener('keydown', this.closeOnEsc);
    window.removeEventListener('popstate', this.removeModal);
    document.body.style.overflow = 'visible';
    document.getElementById('main-content').removeAttribute('aria-hidden');
    document.getElementById('header').removeAttribute('aria-hidden');
    toBeBlurred
      .map(id => document.getElementById(id))
      .filter(Boolean)
      .forEach(element => element.classList.remove('blurred-global'));
  }

  removeModal() {
    this.props.dispatch(loadModal(''));
  }

  closeOnEsc(evt) {
    const key = evt.which || evt.keyCode || 0;

    if (key === ESC_KEY) {
      window.history.back();
      this.removeModal();
    }
  }

  closeOnClick() {
    window.history.back();
    this.removeModal();
  }

  getModalContent(modal) {
    let content = null;
    let className = 'form';
    let closeOnClick = true;

    switch (modal) {
      case 'signup':
        content = <Signup />;
        break;
      case 'follow-facebook':
        content = (
          <FollowFacebook links={this.props.socialMediaLinks.facebook} />
        );
        break;
      case 'follow-twitter':
        content = <FollowTwitter links={this.props.socialMediaLinks.twitter} />;
        break;
      case 'follow-email':
        content = <FollowEmail />;
        break;
      case 'feedback':
        content = <FeedbackForm />;
        className = 'feedback__modal';
        closeOnClick = false;
        break;
      default:
    }

    return { content, className, closeOnClick };
  }

  render() {
    if (!this.props.modal) {
      return null;
    }

    const content = this.getModalContent(this.props.modal);
    return (
      <div className={`modal ${content.className}`}>
        <Overlay
          visible
          onClick={() => content.closeOnClick && this.closeOnClick()}>
          <div className="modal__content" onClick={evt => evt.stopPropagation()}>
            {content.content}
            <button className="modal__content__close" onClick={this.closeOnClick}>
              <i className="icon-x-large" />
              <span className="structural">
                {this.context.app.t('Modal.close')}
              </span>
            </button>
          </div>
        </Overlay>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Page/Modal.jsx